module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/cn.json
// module id = BtGe
// module chunks = 1